import { getAPI } from "./axios-base";
import Admin from "@/models/Admin";

export default class RestResourceSales {
  getSales(params: any) {
    return getAPI.get(`api/rest/v1/sales`, { params });
  }
  getSale(id: string) {
    return getAPI.get(`api/rest/v1/sales/${id}`);
  }
  postSale(body: any) {
    return getAPI.post(`api/rest/v1/sales`, body);
  }
}
